var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade modal-upload",
      attrs: { id: "preInputCopyModal" }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "center-modal" }, [
              _c(
                "div",
                {
                  staticClass:
                    "center-ttl font300 d-flex justify-content-center"
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("voucher.modal-preInputCopy.message")) +
                      "\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-4 no-gutters g-btn-select" }, [
                _c("div", { staticClass: "col-6 pr-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-pink-53 fs-18 w-100",
                      attrs: { "data-toggle": "modal" },
                      on: { click: _vm.setVoucher }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.ok")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 pl-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-gray-53 fs-18 w-100",
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pre-input mt-4 pb-2" },
                _vm._l(_vm.preInputList, function(preInput, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "row no-gutters mt-2" },
                    [
                      _c("div", { staticClass: "col-4 pl-3" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(preInput.label) +
                            "\n                            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-8 pl-2" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(preInput.value) +
                            "\n                            "
                        )
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1986073a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1986073a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Voucher/PreInputCopy.vue
// module id = null
// module chunks = 